import { Input } from 'antd';
import React from 'react';

interface IProps {
    minLength?: number;
    maxLength?: number;
    placeholder?: string;
    onChange?: (e: any) => void;
    field?: any;
    onBlur?: () => void;
    onFocus?: () => void;
    value?: string | ReadonlyArray<string> | number | undefined;
    defaultValue?: string | number | ReadonlyArray<string> | undefined;
    disabled?: boolean;
    className?: string;
    readOnly?: boolean;
    type?: 'hidden' | 'text' | 'password';
    id?: string;
    refInput?: any;
    onKeyDown?: (event: KeyboardEvent) => void;
}

const InputWrap: React.FC<IProps> = ({
    field,
    onChange,
    minLength,
    maxLength,
    placeholder,
    onBlur,
    onFocus,
    value,
    defaultValue,
    disabled,
    readOnly,
    className,
    type = 'text',
    id,
    refInput,
    onKeyDown,
}) => {
    return type == 'password' ? (
        <Input.Password
            className={className}
            onBlur={onBlur}
            onFocus={() => {
                if (onFocus) onFocus();
            }}
            minLength={minLength}
            maxLength={maxLength}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            defaultValue={defaultValue}
            disabled={disabled}
            readOnly={readOnly}
            type={type}
            id={id}
            ref={refInput}
            onKeyDown={onKeyDown}
            {...field}
        />
    ) : (
        <Input
            className={className}
            onBlur={onBlur}
            onFocus={() => {
                if (onFocus) onFocus();
            }}
            minLength={minLength}
            maxLength={maxLength}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            defaultValue={defaultValue}
            disabled={disabled}
            readOnly={readOnly}
            type={type}
            id={id}
            ref={refInput}
            onKeyDown={onKeyDown}
            {...field}
        />
    );
};

export default React.memo(InputWrap);
